export default __webpack_public_path__ + "static/media/file14.ba2260f9.jpg";